/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { Dialog, DialogActions, DialogTitle, IconButton } from '@mui/material';
import PropTypes from 'prop-types';
import _ from 'lodash';
import style from './style';
import ButtonAtom from './../ButtonAtom/index';
import CloseIcon from '@mui/icons-material/Close';

function DialogAtom({
    openDialig,
    buttonSubmitName,
    buttonCloseName,
    dialogHeading,
    resetForm,
    disable,
    handleSubmit,
    onClose,
    content
}) {
    const classes = style();
    const [open, setOpen] = useState(_.cloneDeep(openDialig));

    useEffect(() => {
        if (openDialig) {
            setOpen(true);
        } else {
            setOpen(false);
        }
    }, [openDialig]);

    return (
        <Dialog
            open={open}
            onClose={() => {
                onClose();
                resetForm();
            }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className={classes.dialog}
        >
            <DialogTitle id="alert-dialog-title">
                {dialogHeading}
                <IconButton
                    aria-label="close"
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[800]
                    }}
                    onClick={() => {
                        onClose();
                        resetForm();
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            {content}
            <DialogActions className={classes.dialogButtons}>
                {buttonCloseName ? (
                    <ButtonAtom
                        color="primary"
                        onClick={() => {
                            onClose();
                            resetForm();
                        }}
                        name={buttonCloseName}
                        cclass="cancelBtn"
                    />
                ) : (
                    ''
                )}
                <ButtonAtom
                    color="primary"
                    name={buttonSubmitName}
                    cclass="saveBtn"
                    disabled={disable}
                    onClick={handleSubmit}
                />
            </DialogActions>
        </Dialog>
    );
}

DialogAtom.propTypes = {
    openDialig: PropTypes.bool,
    dialogHeading: PropTypes.string,
    content: ''
};

DialogAtom.defaultProps = {
    openDialig: false,
    dialogHeading: '',
    content: ''
};

export default DialogAtom;
